import { Record, Static, String } from "runtypes";

export const LoginRunType = Record({
  url: String,
});

export interface ILogin extends Static<typeof LoginRunType> {}



// WEBPACK FOOTER //
// ./src/services/ILogin.ts